import React, { useState } from 'react';
import {
    Box, TextField, Button, Typography, Paper, useTheme, CircularProgress, Alert,
    Table, TableBody, TableCell, TableContainer, TableRow, TableHead, Dialog, DialogTitle,
    DialogContent, DialogActions
} from '@mui/material';
import { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import Lottie from 'lottie-react';
import corazonAnim from '../../../img/corazon.json';
import logoseparador from '../../../img/logoseparador.png';
import CryptoJS from 'crypto-js';
import IconButton from '@mui/material/IconButton';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#19438C',
        color: 'white',
        fontSize: 16,
        textAlign: 'center'
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        textAlign: 'center',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
    '&:hover': {
        backgroundColor: '#C1C1C1',
    },
}));

const ListaVerificacionesFeVida = () => {
    const [identidad, setIdentidad] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [datos, setDatos] = useState([]); // Un array vacío
    const theme = useTheme();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [fotoDialogOpen, setFotoDialogOpen] = useState(false);
    const [dialogFotos, setDialogFotos] = useState({ fotoRegistro: null, fotoVerificacion: null });
    const [dialogFotosLoading, setDialogFotosLoading] = useState(false);
    const [dialogFotosError, setDialogFotosError] = useState('');

    const secretKey = "django-insecure-r*+fidc-a5yhm$*h7%2z5k&oly=!1=)3fyyv$tf-k9=qj%55mv";

    const camposAMostrar = [
        { key: 'id', label: 'ID' },
        { key: 'DNI', label: 'Identidad' },
        { key: 'nombres', label: 'Nombre Completo' },
        { key: 'apellidos', label: 'Apellidos' },
        { key: 'fechaNacimiento', label: 'Fecha de Nacimiento' },
        { key: 'sexo', label: 'Sexo' },
        { key: 'celular', label: 'Teléfono Móvil' },
        { key: 'estado', label: 'Estado Fe de Vida' },
        { key: 'foto', label: 'Foto' },

    ];

    const estadosFeVidaTexto = {
        1: 'Proceso Iniciado',
        2: 'Verificación Exitosa',
        3: 'Verificación Fallida',
        4: 'Completado',
        5: 'No Completado'
    };


    const handleInputChange = (e) => {
        const input = e.target.value;
        if (/^\d{0,13}$/.test(input)) {
            setIdentidad(input);
            setError('');
            setResponseMessage('');
            setDatos(null);
        }
    };

    const handleBuscar = async () => {
        if (!identidad) {
            setError('El número de identidad no puede estar vacío');
            return;
        } else if (identidad.length !== 13) {
            setError('El número de identidad debe tener 13 dígitos');
            return;
        }

        setError('');
        setLoading(true);
        setResponseMessage('');
        setDatos(null);

        try {
            const queryString = `DNI=${identidad}`;
            const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(CryptoJS.enc.Hex);

            const formData = new FormData();
            formData.append('DNI', identidad);

            const response = await fetch('https://fevida.injupemp.gob.hn:8443/api/FedeVida/Verificaciones/Pensionado/', {
                method: 'POST',
                headers: {
                    'X-Signature': signature,
                },
                body: formData,
            });

            const text = await response.text();
            if (response.ok) {
                const data = JSON.parse(text);
                setDatos(Array.isArray(data) && data.length ? data : []);
            }
            else {
                setResponseMessage('Error: ' + text);
            }
        } catch (err) {
            setResponseMessage('Error al conectar con el servidor: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    const [rowVerFoto, setRowVerFoto] = useState(null); // agrégalo a los hooks

    const handleVerFoto = async (row) => {
        setDialogFotos({ fotoRegistro: null, fotoVerificacion: null });
        setDialogFotosLoading(true);
        setDialogFotosError('');
        setFotoDialogOpen(true);
        setRowVerFoto(row);  // Guarda el row seleccionado aquí

        try {
            const queryString = `id=${row.id}`;
            const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(CryptoJS.enc.Hex);
            const formData = new FormData();
            formData.append('id', row.id);
            const response = await fetch('https://fevida.injupemp.gob.hn:8443/api/FedeVida/Verificaciones/Consultar/', {
                method: 'POST',
                headers: { 'X-Signature': signature },
                body: formData
            });
            if (!response.ok) {
                const errText = await response.text();
                throw new Error(errText || 'Error al obtener fotos');
            }
            const data = await response.json();
            setDialogFotos({
                fotoRegistro: data.Datos?.foto || null,
                fotoVerificacion: data.FotoRecibida || null,
            });
        } catch (error) {
            setDialogFotosError('No se pudo obtener las fotos: ' + error.message);
        } finally {
            setDialogFotosLoading(false);
        }
    };



    return (
        <>
            <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
                <Paper elevation={2} sx={{ padding: 4, borderRadius: 4, width: '100%', maxWidth: 600 }}>
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <Box width={100}>
                            <Lottie animationData={corazonAnim} loop />
                        </Box>
                        <img src={logoseparador} alt="Logo" style={{ height: 90 }} />
                    </Box>

                    <Typography variant="h5" fontWeight="bold" marginTop={3} gutterBottom align="center">
                        Intentos Verificación Facial - Fe de Vida 2025
                    </Typography>

                    <Typography marginTop={1} gutterBottom align="center">
                        Ingrese el número de identidad del jubilado/pensionado a consultar:
                    </Typography>

                    <TextField
                        label="Número de Identidad"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={identidad}
                        onChange={handleInputChange}
                        error={!!error}
                        helperText={error}
                        inputProps={{ maxLength: 13, inputMode: 'numeric' }}
                    />

                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        size="large"
                        startIcon={loading ? <CircularProgress size={20} /> : <SearchIcon />}
                        onClick={handleBuscar}
                        sx={{ marginTop: 2 }}
                        disabled={loading}
                    >
                        {loading ? 'Consultando...' : 'Buscar'}
                    </Button>

                    {responseMessage && (
                        <Alert severity={datos ? 'success' : 'error'} sx={{ marginTop: 2 }}>
                            {responseMessage}
                        </Alert>
                    )}
                </Paper>
            </Box>

            {/* Tabla con encabezado horizontal */}
            {datos && datos.length > 0 && (
                <TableContainer component={Paper} sx={{ marginTop: 4 }}>
                    <Table>
                        <TableHead>
                            <StyledTableRow>
                                {camposAMostrar.map(({ key, label }) => (
                                    <StyledTableCell key={key}>{label}</StyledTableCell>
                                ))}
                                <StyledTableCell>Ver Foto</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {datos.map((row, idx) => (
                                <StyledTableRow key={row.id || idx}>
                                    {camposAMostrar.map(({ key }) => (
                                        <StyledTableCell key={key}>
                                            {key === 'foto'
                                                ? row.foto
                                                    ? (
                                                        <img
                                                            src={`data:image/jpeg;base64,${row.foto}`}
                                                            alt="Foto"
                                                            style={{ width: 64, height: 64, borderRadius: '8px', objectFit: 'cover' }}
                                                        />
                                                    )
                                                    : '—'
                                                : key === 'estado'
                                                    ? estadosFeVidaTexto[row.estado] || row.estado // aquí el cambio
                                                    : (row[key] ?? '—')}
                                        </StyledTableCell>
                                    ))}

                                    <StyledTableCell>
                                        <Box display="flex" justifyContent="center">
                                            <IconButton
                                                onClick={() => handleVerFoto(row)}
                                                sx={{ width: 48, height: 48 }}
                                            >
                                                <SensorOccupiedIcon fontSize="large" />
                                            </IconButton>

                                        </Box>
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            <Dialog
                open={fotoDialogOpen}
                onClose={() => {
                    setFotoDialogOpen(false);
                    setRowVerFoto(null);
                }}

                maxWidth="sm"
                fullWidth
            >
                <DialogTitle textAlign={'center'}>
                    Fotos de la Verificación
                </DialogTitle>
                <DialogContent dividers>
                    {dialogFotosLoading ? (
                        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight={200}>
                            <CircularProgress sx={{ my: 3 }} />
                            <Typography variant="body2" mt={2}>Cargando fotos...</Typography>
                        </Box>
                    ) : dialogFotosError ? (
                        <Alert severity="error">{dialogFotosError}</Alert>
                    ) : (
                        <Box display="flex" flexDirection="column" gap={4} alignItems="center">
                            {rowVerFoto && rowVerFoto.estado !== 3 && ( // 3 = Verificación Fallida
                                <Box textAlign="center">
                                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                        Foto Registro (RNP/Biometria INJUPEMP)
                                    </Typography>
                                    {dialogFotos.fotoRegistro ? (
                                        <img
                                            src={`data:image/jpeg;base64,${dialogFotos.fotoRegistro}`}
                                            alt="Foto Registro"
                                            style={{ maxWidth: '35%', borderRadius: 12, objectFit: 'contain', border: '2px solid #19438C' }}
                                        />
                                    ) : (
                                        <Typography variant="body2" color="text.secondary">No disponible</Typography>
                                    )}
                                </Box>
                            )}

                            <Box textAlign="center">
                                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                    Foto Verificación
                                </Typography>
                                {dialogFotos.fotoVerificacion ? (
                                    <img
                                        src={`data:image/jpeg;base64,${dialogFotos.fotoVerificacion}`}
                                        alt="Foto Verificación"
                                        style={{ maxWidth: '35%', borderRadius: 12, objectFit: 'contain', border: '2px solid #19438C' }}
                                    />
                                ) : (
                                    <Typography variant="body2" color="text.secondary">No disponible</Typography>
                                )}
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Box width="100%" display="flex" justifyContent="center">
                        <Button
                            onClick={() => {
                                setFotoDialogOpen(false);
                                setRowVerFoto(null);
                            }}
                            color="error"
                            variant="contained"
                            sx={{ minWidth: 100 }}
                        >
                            Cerrar
                        </Button>
                    </Box>
                </DialogActions>

            </Dialog>

        </>
    );
};

export default ListaVerificacionesFeVida;
